import * as React from "react";
import {useState, useEffect} from "react";
import jfetch from "../../utils/jfetch";
import cc from "images/cc_accept.png";
import Button from "../core/Button"
import toast from "../../utils/toast";


function Upgrade(props){
  const [fields, set_fields] = useState({fname:"", lname:"", address:"", address2:"", country:"", st:"", zip:"", nameoncard:"", cc:"", exp:"", ccv:""});
  const [errors, set_errors] = useState({fname:0, lname:0, address:0, country:0, st:0, zip:0, nameoncard:0, cc:0, exp:0, ccv:0});
  const [loading, setLoading] = useState(false)

  async function proccess_payment(){
    const resp = await jfetch.get(`/purchases/process_payment`, {
      cc:fields.cc, 
      exp:fields.exp, 
      amount: props.product.amount,
      fname:fields.fname,
      lname:fields.lname,
      address:fields.address,
      country:fields.country,
      st:fields.st,
      zip:fields.zip,
      nameoncard:fields.nameoncard,
      ccv:fields.ccv,
      product_id:props.product.id
    })
    return resp
  }
  
  async function save_payment(succeded, response_code, response_text, tid){
    const purchase = {
      label: props.product.label, 
      price: props.product.amount, 
      succeded:succeded, 
      response_code: response_code, 
      response_text: response_text,
      transaction_id:tid,
      organization_id:props.userContext.organization.data.id,
      user_id:props.userContext.user.data.id
    }
    return await jfetch.post('/purchases', {purchase:purchase, product_id:props.product.id})
  }

  async function create_ticket(user_name, org_name, product_name, product_price, result, response_text, tid){
    const params = {
      companyid: "CharTec",
      subject: `Membership Purchased on CORE`,
      message: `A Core Membership Purchase Attempt Was Made:
                \n ${user_name} from ${org_name} tried to purchase ${product_name} for $${product_price}
                \n Purchase Succeded: ${result}
                \n BNG response text: ${response_text}
                \n Transaction ID: ${tid}`,
      board: "chartec orders placed",
      recid: 2
    };
    return await jfetch.post('/api/ct_cw/create_ticket', params);
  }
  
  async function run_payment(){
    setLoading(true)
    const processed = await proccess_payment()
    const succeded = processed.result.response[0] == '1' ? true : false
    const saved = await save_payment(succeded, processed.result.response[0], processed.result.responsetext[0], processed.result.transactionid[0])
    await create_ticket(
      props.userContext.user.data.attributes.name, 
      props.userContext.organization.data.attributes.title,
      saved.purchase.label,
      saved.purchase.price,
      saved.purchase.succeded,
      saved.purchase.response_text,
      saved.purchase.transaction_id
    )
    setLoading(false)
    if(saved.purchase.response_code == '1'){
      window.location.replace('/thankyou');
    }
    else{
      toast.error(`Payment Failed: ${saved.purchase.response_text}`)
    }
  }  


  function handleChange(hook, event, key, fields){
    hook({...fields, [key]:event.target.value});
  }
  
  function validation(event,errors,set_errors, fields){
    event.preventDefault();
    Object.entries(fields).forEach(([key, value]) => {
      if(value != '' || key == 'address2'){
        set_errors({...errors, [key]:0});
        errors[key] = 0;
      } else {
        set_errors({...errors, [key]:1});
        errors[key] = 1;
      }
    });
    var hasErrors = Object.keys(errors).some(k => errors[k]);
    if(!hasErrors){
      run_payment()
    }
  
  }  
  
  return(
    <span>
      <div className="col-md-7 order-md-1">
          <h4 className="mb-3">Billing address</h4>
          <form className="needs-validation was-validated">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label>First name</label>
                <input type="text" className="form-control" id="firstName" placeholder="" value={fields.fname}  onChange={() => handleChange(set_fields, event, 'fname', fields)}/>
                {errors.fname == 1 ? <div className="invalid-feedback">
                  Valid first name is required.
                </div> : ""}
              </div>
              <div className="col-md-6 mb-3">
                <label >Last name</label>
                <input type="text" className="form-control" id="lastName" placeholder="" value={fields.lname}  onChange={() => handleChange(set_fields, event, 'lname', fields)}/>
                {errors.lname == 1 ? <div className="invalid-feedback">
                  Valid last name is required.
                </div> : ""}
              </div>
            </div>

            <div className="mb-3">
              <label>Address</label>
              <input type="text" className="form-control" id="address" placeholder="1234 Main St" value={fields.address}  onChange={() => handleChange(set_fields, event, 'address', fields)}/>
              {errors.address == 1 ? <div className="invalid-feedback">
                Please enter your shipping address.
              </div> : ""}
            </div>

            <div className="mb-3">
              <label>Address 2 <span className="text-muted">(Optional)</span></label>
              <input type="text" className="form-control" id="address2" placeholder="Apartment or suite" value={fields.address2}  onChange={() => handleChange(set_fields, event, 'address2', fields)}/>
            </div>

            <div className="row">
              <div className="col-md-5 mb-3">
                <label>Country</label>
                <select className="custom-select d-block w-100" id="country" onChange={() => handleChange(set_fields, event, 'country', fields)}>
                  <option value="">Choose...</option>
                  <option>United States</option>
                </select>
                {errors.country == 1 ? <div className="invalid-feedback">
                  Please select a valid country.
                </div> : ""}
              </div>
              <div className="col-md-4 mb-3">
                <label>State</label>
                <select className="custom-select d-block w-100" id="state" onChange={() => handleChange(set_fields, event, 'st', fields)}>
                  <option value="">Choose...</option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </select>
                {errors.st == 1 ? <div className="invalid-feedback">
                  Please provide a valid state.
                </div> : ""}
              </div>
              <div className="col-md-3 mb-3">
                <label>Zip</label>
                <input type="text" className="form-control" id="zip" placeholder="" value={fields.zip}  onChange={() => handleChange(set_fields, event, 'zip', fields)}/>
                {errors.zip == 1 ? <div className="invalid-feedback">
                  Zip code required.
                </div> : ""}
              </div>
            </div>

            <h4 className="mb-3">Payment</h4>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label>Name on card</label>
                <input type="text" className="form-control" id="cc-name" placeholder="" value={fields.nameoncard}  onChange={() => handleChange(set_fields, event, 'nameoncard', fields)}/>
                <small className="text-muted">Full name as displayed on card</small>
                {errors.nameoncard == 1 ? <div className="invalid-feedback">
                  Name on card is required
                </div> : ""}
              </div>
              <div className="col-md-6 mb-3">
                <label>Credit card number</label>
                <input type="text" className="form-control" id="cc-number" value={fields.cc}  onChange={() => handleChange(set_fields, event, 'cc', fields)}/>
                {errors.cc == 1 ? <div className="invalid-feedback">
                  Credit card number is required
                </div> : ""}
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 mb-3">
                <label>Expiration</label>
                <input type="text" className="form-control" id="cc-expiration" placeholder="" value={fields.exp}  onChange={() => handleChange(set_fields, event, 'exp', fields)}/>
                {errors.exp == 1 ? <div className="invalid-feedback">
                  Expiration date required
                </div> : ""}
              </div>
              <div className="col-md-3 mb-3">
                <label>CVV</label>
                <input type="number" className="form-control" id="cc-cvv" placeholder="" value={fields.ccv}  onChange={() => handleChange(set_fields, event, 'ccv', fields)}/>
                {errors.ccv == 1 ? <div className="invalid-feedback">
                  Security code required
                </div> : ""}
              </div>
              <div className="col-md-3 mb-3">
                <img src={cc} style={{width : "100%"}}/>
              </div>
            </div>
            <hr className="mb-4"/>
            <div style={{marginBottom : "30px"}}>
              <Button loading={loading} color="primary" size="lg" className="btn btn-primary btn-lg btn-block" onClick={() =>validation(event,errors,set_errors, fields)}>
                Check Out
              </Button>
            </div>
            
          </form>
        </div>
        <div className="col-md-4 order-md-2 mb-4">
          <ul className="list-group mb-3" style={{marginTop : "60px"}}>
            <li className="list-group-item d-flex justify-content-between lh-condensed" style={{display:'flex', alignItems:'baseline'}}>
              <div>
                <h6 className="my-0 rem1">{props.product.label}</h6>
                <small className="text-muted">{props.product.desc}</small>
              </div>
              <span className="price">${props.product.amount}</span>
            </li>
            <li className="list-group-item d-flex justify-content-between">
              <span>Total (USD)</span>
              <strong className="right-float">${props.product.amount}</strong>
            </li>
          </ul>
        </div>
      </span>
  );
}



export default Upgrade


// WEBPACK FOOTER //
// ./app/javascript/components/pages/Upgrade.tsx